import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Phone, CalendarCheck } from "lucide-react";
export default function FinalCallToAction() {
  return <section id="finalcalltoaction" className="w-full py-24 md:py-32 bg-background text-foreground">
      <div className="container mx-auto px-4 md:px-6 flex flex-col items-center text-center">
        <h2 className="font-default text-5xl md:text-6xl lg:text-7xl font-bold tracking-tighter mb-6 max-w-5xl uppercase leading-tight">
          Claim Your Free Cape Coral Pest Inspection
        </h2>
        
        <p className="font-serif text-xl md:text-2xl mb-10 max-w-3xl text-foreground/90 leading-relaxed">
          Don't let pests take over your home. Trust Peace River Pest Control for fast, reliable, and fully licensed local service. Reclaim your peace of mind today.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto justify-center">
          <Button size="lg" className="rounded-full h-16 px-10 text-xl font-default shadow-lg hover:shadow-xl transition-all" asChild>
            <Link to="/contact">
              <CalendarCheck className="mr-2 size-6" />
              Get A Free Quote
            </Link>
          </Button>
          
          <Button size="lg" className="rounded-full h-16 px-10 text-xl font-default shadow-lg hover:shadow-xl transition-all bg-primary text-primary-foreground hover:bg-primary/90" asChild>
            <Link to="tel:941-888-0485">
              <Phone className="mr-2 size-6" />
              Call Now
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}